import { useState, VFC } from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import type { Image } from '../../reducks/products/types';
// import NoImage from '../../../public/img/no_image.png';
import './overlap_swiper.css'  // swiperの色を変更するcss

type Props = {
  images: Array<Image>;
};

export const ImageSwiper: VFC<Props> = (props) => {
  const { images } = props;

  const [params] = useState({
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets' as const,
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    spaceBetween: 0,
  });

  return (
    <Swiper {...params}>
      {images.length === 0 ? (
        <div>
          <img
            src={'/img/no_image.png'}
            alt='イメージなし'
            className='w-80 h-80 sm:w-96 sm:h-96 object-cover mx-auto'
          />
        </div>
      ) : (
        images.map((image: Image) => (
          <div key={image.id}>
            <img
              src={image.path}
              alt={'商品画像'}
              className='w-80 h-80 sm:w-96 sm:h-96 object-cover mx-auto'
            />
          </div>
        ))
      )}
    </Swiper>
  );
};
